module.exports = __webpack_public_path__ + "img/claim-reward-screen.2b9e7fe0.png";